module.exports = __webpack_public_path__ + "static/media/image4.69d2ef8a.jpeg";